import { Injectable } from '@angular/core';
import { MessageService } from '../global/message.service';
import { CommonService } from '../global/common.service';
import { ApiService } from '../global/api.service';

import { HelperService } from '../global/helper.service';
import { ThrowStmt } from '@angular/compiler';
import { Router, ActivatedRoute } from '@angular/router';
import { AMT } from 'app/shared/models/computaion-return/schedule-amt';
import { AMTCMain, AMTC } from 'app/shared/models/computaion-return/schedule-amtc';

@Injectable({
  providedIn: 'root'
})
export class ComputationReturnService {

  is_computation_display: Boolean = true;
  is_return_filing: Boolean = false;
  is_signing_information: Boolean = false;
  is_amt_amtc: Boolean = false;


  is_Bti: Boolean = true;
  is_si: Boolean = false;
  is_amtamtc: Boolean = false;

  is_amt: Boolean = true;
  is_amtc: Boolean = false;

  person_dob: any = null;
  residential_Status: any = null;
  partyType: any = null;
  party: any = null;

  total_Income: any = 0;
  tax_Payable: any = 0;
  taxstatus = 'Balance Tax Payable';

  c_total: any = 0;
  c_losses_of_current_year_set_off: any = 0;
  total_hp: any = 0;

  amt: AMT = new AMT();
  amtcMain: AMTCMain = new AMTCMain;
  amtcAutoMode: Boolean = true;
  f_id: any = null;
  p_id: any = null;
  itr_id: any = null;
  btiBTTIData: any = null;
  errorMsg: any = '';
  lastAssesmentYear: any = null;
  secondLastAssesmentYear: any = null;

  constructor(public common: CommonService, public activatedRoute: ActivatedRoute, public message: MessageService, public api: ApiService, public sCommon: CommonService, public sHelper: HelperService) {
    this.activatedRoute.queryParams.subscribe(params => {
      this.p_id = this.common.personID;
      this.f_id = this.common.selectedYearId;
      this.party = JSON.parse(atob(localStorage.getItem('party_type')));
      this.amt = new AMT();
      this.person_dob = new Date(this.party.dob);
      this.residential_Status = this.party.residential_Status;
      this.partyType = this.party.party_type;
      this.itr_id = this.party.selected_itr_id;
    });
  }


  getBTIBTTIData(personId, financialId) {
    return new Promise((resolve, reject) => {
      this.message.loading = true;
      this.api.get(`tti_itr_service/computaion_display/${personId}/${financialId}`).subscribe(
        (res) => {
          this.btiBTTIData = res['data'];
          console.log("btiBTTIData",this.btiBTTIData);
          if (this.itr_id !== 1 && this.itr_id !== 4) {
            this.initAMTC();
            this.amtCalculation();
          }
          this.message.loading = false;
          resolve(res)
        }, (err) => {
          this.message.loading = false;
          reject(err);
        });
    });
  }


  initAMTC() { 
    this.amtcMain.amtc1 = this.btiBTTIData['tax_payable_deemed_total_btti1d'] != null ? this.btiBTTIData['tax_payable_deemed_total_btti1d'].toFixed() : 0;
    this.amtcMain.amtc2 = this.btiBTTIData['tax_payable_btti2i'] != null ? this.btiBTTIData['tax_payable_btti2i'].toFixed() : 0;
   
    var amtc1:number=+this.amtcMain.amtc1;
    var amtc2:number=+this.amtcMain.amtc2;
    if (amtc2 > amtc1) {
      this.amtcMain.amtc3 = (this.sHelper.getZeroIfNull(this.amtcMain.amtc2) - this.sHelper.getZeroIfNull(this.amtcMain.amtc1));
    } else {
      this.amtcMain.amtc3 = 0
    }
    const previousYear = 2013;
    const currentYear = this.sCommon.assessmentYear;
    const newAssessmentYear = [];
    let m = 0;
    // if (this.common.selectedYearId == 1) {
    //   m = 0;
    // } else if (this.common.selectedYearId == 2) {
    //   m = 0;
    // }
    for (let i = previousYear + m; i <= currentYear; i++) {
      const obj = new AMTC;
      const nextYear = ((i + 1).toString()).split('');
      const assessment_year = `${i}-${nextYear[2]}${nextYear[3]}`;
      obj.assmt_year = assessment_year;
      newAssessmentYear.push(obj);
    }
    this.amtcMain.assmt_years = newAssessmentYear;
    this.secondLastAssesmentYear = this.amtcMain.assmt_years[this.amtcMain.assmt_years.length - 2].assmt_year;
    this.lastAssesmentYear = this.amtcMain.assmt_years[this.amtcMain.assmt_years.length - 1].assmt_year;
  }

  amtCalculation() {
    this.amt.amt1 = this.btiBTTIData['total_income'];
    this.amt.amt2a = this.btiBTTIData['deduction_part_c'];
    this.amt.amt2b = this.btiBTTIData['deduction_10aa'];
    this.amt.amt2 = this.sHelper.getZeroIfNull(this.amt.amt2a) + this.sHelper.getZeroIfNull(this.amt.amt2b) + this.sHelper.getZeroIfNull(this.amt.amt2c);
    this.amt.amt3 = this.sHelper.getZeroIfNull(this.amt.amt1) + this.sHelper.getZeroIfNull(this.amt.amt2);
    if (this.common.selectedItrId == 3 && this.common.selectedYearId == 4) {
      this.amt.amt3b = this.sHelper.getZeroIfNull(this.amt.amt3) - this.sHelper.getZeroIfNull(this.amt.amt3a);
    }
    this.amt.amt4 = this.btiBTTIData['tax_deemed_115jc_btti1a'];
  }

  amtcMainCalculation() {
      
    let i = 0;
    this.amtcMain.amtc4_b1 = 0;
    this.amtcMain.amtc4_b2 = 0;
    this.amtcMain.amtc4_b3 = 0;
    this.amtcMain.amtc4_c = 0;
    this.amtcMain.amtc4_d = 0;

    this.amtcMain.assmt_years.forEach(assmtYear => {
      if (i > this.amtcMain.assmt_years.length - 3) {
        assmtYear.credit_utilised_b2 = null;
      }
      if (i < this.amtcMain.assmt_years.length - 1) {

        this.amtcMain.amtc4_b1 += this.sHelper.getZeroIfNull(assmtYear.gross_b1);
        if (this.sHelper.getZeroIfNull(assmtYear.credit_utilised_b2) > this.sHelper.getZeroIfNull(assmtYear.gross_b1)) {
          assmtYear.credit_utilised_b2 = assmtYear.gross_b1;
        }
        this.amtcMain.amtc4_b2 += this.sHelper.getZeroIfNull(assmtYear.credit_utilised_b2);
        assmtYear.credit_carried_forward_b3 = this.sHelper.getZeroIfNull(assmtYear.gross_b1) - this.sHelper.getZeroIfNull(assmtYear.credit_utilised_b2);
        this.amtcMain.amtc4_b3 += assmtYear.credit_carried_forward_b3;
        if (this.amtcMain.mode) {
          assmtYear.set_off_in_earlier_c = Math.min(this.sHelper.getZeroIfNull(assmtYear.credit_carried_forward_b3), this.sHelper.getZeroIfNull(this.amtcMain.amtc3 - this.amtcMain.amtc4_c));
        } else if (this.sHelper.getZeroIfNull(assmtYear.set_off_in_earlier_c) > this.sHelper.getZeroIfNull(assmtYear.credit_carried_forward_b3)) {
          this.message.displaySnackbar("Amount entered in 'AMT Credit Utilised' cannot exceed Amount available in 'Balance brought forward'");
          assmtYear.set_off_in_earlier_c = this.sHelper.getZeroIfNull(assmtYear.credit_carried_forward_b3);
        }
        this.amtcMain.amtc4_c += this.sHelper.getZeroIfNull(assmtYear.set_off_in_earlier_c);
        assmtYear.balance_budget_forward_d = this.sHelper.getZeroIfNull(assmtYear.credit_carried_forward_b3) - this.sHelper.getZeroIfNull(assmtYear.set_off_in_earlier_c);
        this.amtcMain.amtc4_d += this.sHelper.getZeroIfNull(assmtYear.balance_budget_forward_d);
      }
      else if (i > this.amtcMain.assmt_years.length - 2) {
        assmtYear.gross_b1 = this.amtcMain.amtc1 > this.amtcMain.amtc2 ? this.amtcMain.amtc1 - this.amtcMain.amtc2 : 0;
        this.amtcMain.amtc4_b1 += assmtYear.gross_b1;
        assmtYear.balance_budget_forward_d = assmtYear.gross_b1;
        this.amtcMain.amtc4_d += this.sHelper.getZeroIfNull(assmtYear.balance_budget_forward_d);
      }
      this.amtcMain.amtc5 = this.amtcMain.amtc4_c;
      this.amtcMain.amtc6 = this.amtcMain.amtc4_d;
      i++;
      if(this.amtcMain.amtc4_c > this.amtcMain.amtc3){
        this.errorMsg = "Total amount entered in 'AMT Credit Utilised' cannot exceed Amount available in 'Amount of tax against which credit is available'";
        this.message.displaySnackbarpersonalInfo("Total amount entered in 'AMT Credit Utilised' cannot exceed Amount available in 'Amount of tax against which credit is available'");
      } else {
        this.errorMsg = '';
      }
    });
  }

  getAMT(personId, financialId) {
    this.message.loading = true;
    return new Promise((resolve, reject) => {
      this.api.get(`amt?personId=${personId}&financialId=${financialId}`).subscribe(
        (res) => {
          this.message.loading = false;
          resolve(res)
        }, (err) => {
          this.message.loading = false;
          reject(err);
        });
    });
  }

  saveAMT(data) {
    this.message.loading = true;
    return new Promise((resolve, reject) => {
      this.api.post(`amt`, data).subscribe(
        (res) => {
          this.message.loading = false;
          resolve(res)
        }, (err) => {
          this.message.loading = false;
          reject(err);
        });
    });
  }

  getAMTC(personId, financialId) {
    this.message.loading = true;
    return new Promise((resolve, reject) => {
      this.api.get(`amtcmain?personId=${personId}&financialId=${financialId}`).subscribe(
        (res) => {
          // this.amtcMainCalculation();
          this.message.loading = false;
          resolve(res);
        }, (err) => {
          this.message.loading = false;
          reject(err);
        });
    });
  }

  saveAMTC(data) {
    this.message.loading = true;
    return new Promise((resolve, reject) => {
      this.api.post(`amtcmain`, data).subscribe(
        (res) => {
          this.message.loading = false;
          resolve(res);
        }, (err) => {
          this.message.loading = false;
          reject(err);
        });
    });
  }

  roundOf10Factor(amount) {
    const lastDigit = amount % 10;
    if (lastDigit < 5) {
      return amount - lastDigit;
    } else {
      return (amount + (10 - lastDigit));
    }
  }

  checkYear() {
    if (this.common.assessmentYear) {
      const year = this.common.assessmentYear
      let nextYear = parseInt(this.common.assessmentYear) + 1;
      nextYear = nextYear % 100;
      return year + '-' + nextYear
    }
  }

  convertToRoman(num) {
    const arrConv = { 1: 'I', 2: 'II', 3: 'III', 4: 'IV', 5: 'V', 6: 'VI', 7: 'VII', 8: 'VIII', 9: 'IX', 10: 'X', 20: 'XX', 30: 'XXX', 40: 'XL', 50: 'L', 60: 'LX', 70: 'LXX', 80: 'LXXX', 90: 'XC', 100: 'C', 200: 'CC', 300: 'CCC', 400: 'CD', 500: 'D', 600: 'DC', 700: 'DCC', 800: 'DCCC', 900: 'CM', 1000: 'M', 2000: 'MM', 3000: 'MMM', 4000: 'MMMM', 5000: 'MMMMM', 6000: 'MMMMMM', 7000: 'MMMMMMM', 8000: 'MMMMMMMM', 9000: 'MMMMMMMMM' };

    let arr = num.toString().split('').reverse(),
      i = 1, k;
    for (k = 0; k < arr.length; k++) {
      arr.splice(k, 1, arr[k] * i);
      i *= 10;
    }

    const romansArray = [];
    for (i = 0; i < arr.length; i++) {
      romansArray.push(arrConv[arr[i]] || '');
    }
    
    return romansArray.reverse().join('');
  }

}

